

$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });



  $('.contents_tab li:not(.blank)').click(function(){
    var num = $(this).data('c');
    $('.contents_tab li').removeClass();
    $(this).addClass('active');
    $('.contents_container').removeClass('active');
    $('#contents'+num+'').addClass('active');
    if (num > 6) {
      $('.contents_tab li').each(function(){
        if ($(this).data('c') > 6) {
          $(this).addClass('tab_bottom');
        }else{
          $(this).addClass('tab_top');
        }
      });
    }else{
      $('.contents_tab li').each(function(){
        if ($(this).data('c') <= 6) {
          $(this).addClass('tab_bottom');
        }else{
          $(this).addClass('tab_top');
        }
      });
    }
    setTimeout(function(){
      $('.contents_img').removeClass('active');
      $('#contents'+num+' .contents_img').addClass('active');
    },10);
  });

});

$(window).on('load scroll',function(){
  setTimeout(function(){
    $('.mv').addClass('active');
    $('.mv_copyright').addClass('active');
  },1000);
});
